// 3rd party
import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'mask',
  templateUrl: './mask.component.html',
  styleUrls: ['./mask.component.css']
})
export class MaskComponent {
  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/mask/mask.component.ts